import type { Highlight, TextHighlight, PolygonHighlight } from '../types';

export function stripHtml(html: string): string {
    const tmp = document.createElement('div');
    tmp.innerHTML = html;
    return tmp.textContent ?? tmp.innerText ?? '';
}

export function truncate(str: string, max: number): string {
    return str.length > max ? str.slice(0, max) + '…' : str;
}

export function formatTime(iso: string): string {
    try {
        const d = new Date(iso);
        if (isNaN(d.getTime())) return '';
        const pad = (n: number) => String(n).padStart(2, '0');
        return `${pad(d.getDate())}.${pad(d.getMonth() + 1)}.${d.getFullYear()} ${pad(d.getHours())}:${pad(d.getMinutes())}`;
    } catch {
        return '';
    }
}

export function typeIcon(h: Highlight): string {
    if (h.type === 'none') return 'fa-regular fa-note-sticky';
    const prefix = h.type === 'rect' ? 'fa-regular' : 'fa-solid';
    const icon =
        h.type === 'text' ? 'fa-highlighter'
        : h.type === 'polygon' ? 'fa-draw-polygon'
        : h.type === 'rect' ? 'fa-square'
        : 'fa-location-dot';
    return `${prefix} ${icon}`;
}

export function typeLabel(h: Highlight): string {
    if (h.type === 'text') return truncate((h as TextHighlight).text, 40);
    if (h.type === 'polygon') return `Фигура (${(h as PolygonHighlight).points.length} точек)`;
    if (h.type === 'rect') return 'Прямоугольник';
    if (h.type === 'none') return 'Без выделения на странице';
    return 'Метка';
}
